export interface WebhookChannels {
    channelId: number;
    name: string;
    logo: any;
}

export interface WebhookHeader {
    name?: string;
    value?: string;
}

export interface WebhookConfig {
    webhookUrl: string;
    webhookHmacSecret?: string;
    channels: number[];
    eventTypes?: string[];
    additionalHeaders: WebhookHeader[];
    isSystem?: boolean;
}

export enum WebhookEventTypes {
    orderNotifications = 'orders.notification',
    customerFirstNameUpdate = 'customer.firstName.updated',
    customerLastNameUpdate = 'customer.lastName.updated',
    customerEmailUpdate = 'customer.email.updated',
    customerBadgeAdded = 'customer.badge.added',
    customerBadgeNumberUpdate = 'customer.badge.number_updated',
    customerBadgeDeleted = 'customer.badge.deleted',
    customerBadgeSetDefault = 'customer.badge.set_default',
    customerBadgeBlocked = 'customer.badge.blocked',
    customerBadgeTypeUpdate = 'customer.badge.type_updated',
    transactionsNotification = 'transactions.notification',
}

// Shared types for form handling
export type HandleSubmitFn = (data: WebhookConfig) => void;

export type FormRefType = {
    handleSubmit: (fn: HandleSubmitFn) => () => void;
    reset: (data: any) => void;
};

// Shared constants
export const DEFAULT_WEBHOOK_CHANNELS = [1, 2, 5, 8, 12];

// Utility functions
export const buildEventTypeString = (eventTypes?: string[]): string => {
    return eventTypes && eventTypes.length > 0 ? eventTypes.join(',') : WebhookEventTypes.orderNotifications;
};

export const resetFormWithWebhookData = (updateResult: any, originalChannels: number[]) => ({
    ...updateResult,
    channels: originalChannels,
    additionalHeaders: [...updateResult.additionalHeaders, { name: '', value: '' }],
});
